<template>
  <div class="aboutCenter clearfix">
    <div class="main yuanjiao moshaBox">
      <h1>雪帝 · 经销商</h1>
      <div class="inputBox">
        <div class="form-group">
          <label>账号</label>
          <input type="text" v-model="user" class="form-control form-control-lg">
        </div>
        <div class="form-group">
          <label>密码</label>
          <input type="password" v-model="pwd" class="form-control form-control-lg">
        </div>
        <router-link tag='a' class="description huanchongZhong yuanjiao" to="/retrieve">
          <div class="mb-3 text-danger">
            <i class="iconfont icon-jinggao"></i> 忘记密码?
          </div>
        </router-link>
        <button type="submit" class="btn btn-secondary btn-block btn-lg" @click="loginFun">
          <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          立即登录
        </button>
        <div class="description">
          <router-link tag='a' class="description huanchongZhong yuanjiao" to="/about">
            — 联系我们申请账号 —
          </router-link>
        </div>
      </div>
      <div class="bg"></div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'aboutCenter',
  data () {
    return {
      user: '',
      pwd: '',
      isLoading: false,
      isCheck: false
    }
  },
  components:{
  },
  methods:{
    loginFun() {
      EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
      this.isLoading = true;
      // 可以执行登录
      resultCommons.apiUserlogin(this, { user: this.user, pwd: this.pwd , isCheck: this.isCheck }).then(app=>{
        EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
        this.isLoading = false;
      });
    }
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style>
</style>
<style scoped lang='less'>
.aboutCenter{
  //margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
  h1{
    //margin-bottom: 40px;
    text-align: center;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding-bottom: 50px;
  }
  div.main{
    width: 50vw;
    /*background:rgba(0,0,0,1);*/
    padding:60px 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    div.bg{
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background:#FFFFFF url("/static/images/wordbg.png") no-repeat center center;
      background-size: auto 100%;
      z-index: 0;
      /*filter: blur(15px);*/
    }
    h1{
      position: relative;
      z-index: 1;
    }
    div.inputBox{
      width: 360px;
      position: relative;
      z-index: 1;
      div.description{
        text-align: center;
        margin-top: 50px;
      }
    }
  }
}
@media (max-width: 992px) {
  .aboutCenter{
    div.main{
      width: 100%;
      padding:100px 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      div.inputBox{
        width: 100%;
        div.description{
          text-align: center;
          margin-top: 50px;
        }
      }
    }
  }
}
@media (max-width: 727px) {
  .aboutCenter{
    div.main{
      width: 100%;
      padding:100px 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      div.inputBox{
        width: 100%;
        div.description{
          text-align: center;
          margin-top: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/Center.vue